module.exports = __webpack_public_path__ + "static/media/1009836.b63a2c5f.jpg";